import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from 'client/components/GDS/Button/Button';
import Icon from '@mdi/react';
import { mdiBackspaceReverse } from '@mdi/js';
import { VALID_MODES } from './ClearButton.mode';
import { mapModeIsValid } from '../validateModes';
import { ClearModal } from './ClearModal/ClearModal';
import { isAOIToClear, useClearAOI } from 'client/pages/MapPage/hooks/clearAOI';
import { useState } from 'react';

const ClearButton = ({
    mapMode
}) => {
    const intl = useIntl();
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const clearAOI = useClearAOI();

    const clearCallbackAction = () => {
        setConfirmDialogOpen(false);
    };

    const clear = () => {
        clearAOI(clearCallbackAction);
    };

    const handleClear = () => {
        if (isAOIToClear(mapMode)) {
            setConfirmDialogOpen(true);
        } else {
            clear();
        }
    };

    return mapModeIsValid(mapMode, VALID_MODES)
        ? <>
            <Button
                data-testid="mapToolBar.clearButton"
                variant="warning"
                onClick={handleClear}
            >
                <Icon path={mdiBackspaceReverse} size={0.7}/>
                { intl.formatMessage({ id: 'mapToolbar.clearButton.text' }) }
            </Button>
            <ClearModal handleConfirm={clear} clearModalOpen={confirmDialogOpen} setClearModalOpen={setConfirmDialogOpen} />
        </>
        : null;
};

ClearButton.propTypes = {
    mapMode: PropTypes.array
};

const mapStateToProps = state => {
    const { map } = state;
    return {
        mapMode: map?.mode || []
    };
};

export default connect(mapStateToProps)(ClearButton);
